import { render, staticRenderFns } from "./InstitutionDashboard.vue?vue&type=template&id=c64ac14c&scoped=true&"
import script from "./InstitutionDashboard.vue?vue&type=script&lang=ts&"
export * from "./InstitutionDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./InstitutionDashboard.vue?vue&type=style&index=0&id=c64ac14c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64ac14c",
  null
  
)

export default component.exports